export default __webpack_public_path__ + "static/carousel2-a7cd6e090590fd097c5267da4d454326.png";